module.exports = __webpack_public_path__ + "static/img/岚图梦想家.bad2c76b.png";